import {Box, Center, Icon, Show, Spinner, Text, VStack} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import {FinancingPromoPlaceholder} from './types/FinancingPromoPlaceholder';
import {getFinancialProductTypeLabel} from './utils/getFinancialProductTypeLabel';
import {getFinancingPlaceholderText} from './utils/getFinancingPlaceholderText';

interface FinancingPlaceholderTileProps extends TestIdProps {
  placeholder: FinancingPromoPlaceholder;
}

// Stands in for a financing promo card that has no rendered file yet and tells why.
export function FinancingPlaceholderTile(props: FinancingPlaceholderTileProps) {
  const isPending = props.placeholder.status === 'PENDING';

  return (
    <Box
      width="100%"
      height="100%"
      padding={2}
      backgroundColor="palettes.neutral.10.100"
      data-testid={suffixTestId('financingPlaceholder', props)}
    >
      <Center width="100%" height="100%">
        <VStack spacing={1} align="center">
          <Show when={isPending}>
            <Spinner size="small" />
          </Show>
          <Show when={!isPending}>
            <Icon value="alert/warning" color="severity.warning" size={5} />
          </Show>
          <Text size="xSmall" color="secondary" align="center">
            {getFinancialProductTypeLabel(props.placeholder.financialProductType)}
          </Text>
          <Text size="xSmall" align="center">
            {getFinancingPlaceholderText(props.placeholder)}
          </Text>
        </VStack>
      </Center>
    </Box>
  );
}
